'use client'
import {
  minifyGqlQuery
} from "./chunk-SQE4KWHX.mjs";
import {
  SEO_QUERY
} from "./chunk-W3K3QG4J.mjs";
import {
  TAG_QUERY
} from "./chunk-MWW3YBFP.mjs";
import {
  OTHER_BOOKING_OPTIONS_QUERY
} from "./chunk-6KZWPHJX.mjs";
import {
  LOCATION_QUERY
} from "./chunk-RJD7S7WV.mjs";
import {
  SCHEDULE_QUERY
} from "./chunk-5GNKV3HD.mjs";
import {
  LINK_QUERY
} from "./chunk-Y5YNZ765.mjs";
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";
import {
  getContentfulSafeLocale
} from "./chunk-2QEV6CST.mjs";
import {
  requestWithRateLimitHandling
} from "./chunk-DZ54PK2S.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/experiences/detail.ts
import { useQuery } from "@tanstack/react-query";
import { gql } from "graphql-request";
import { Exception } from "@wbk/logger";
var QUERY = gql`
  query getExperienceDetail($lang: String, $limit: Int, $skip: Int, $where: ExperienceFilter, $order: [ExperienceOrder]) {
    experienceCollection(locale: $lang, limit: $limit, skip: $skip, where: $where, order: $order) {
      total
      items {
        __typename
        sys { id }
        id
        title
        subtitle
        description
        slug
        ticketingUrlSlug
        image11{${IMAGE_QUERY}}
        image31{${IMAGE_QUERY}}
        startingPrice
        discountedPrice
        currencyCode
        schedule{${SCHEDULE_QUERY}} 
        buttonLabel
        cardButtonLabel        
        zoneEntryIncluded
        eventType
        authGaurd
        buttonLink
        carousalCollection(limit: 40) {
          items {${IMAGE_QUERY}}
        }
        cmsTagsCollection(limit: 10){
          items {${TAG_QUERY}}
        }
        season{title slug}
        zone{
          id slug title zoneLogo{${IMAGE_QUERY}} sponsorLogo{${IMAGE_QUERY}}
        }
        location{${LOCATION_QUERY}}
        category{id title slug}
        sponsorsCollection(limit: 20) {
          items {
            id
            title
            titleColor
            sponsorsCollection(limit: 20) {
              items {
                id
                title
                logo {${IMAGE_QUERY}}
                link
              }
            }
          }
        }
        isComingSoon
        richTerms { json }
        whatToKnow
        specialPromotion
        ticketingUrlSlug
        showResellBanner
        socialLinks {
          id
          title
          iconLinksCollection(limit: 10) {
            items {${LINK_QUERY}}
          }
        }
        seo{${SEO_QUERY}}
        otherBookingSection {${OTHER_BOOKING_OPTIONS_QUERY}}
        hyProperties
        visibility
      }
    }
  }
`;
var getExperienceDetail = (props) => __async(void 0, null, function* () {
  var _a, _b, _c;
  try {
    const res = yield requestWithRateLimitHandling(minifyGqlQuery(QUERY), __spreadProps(__spreadValues({
      order: "order_ASC"
    }, props), {
      lang: getContentfulSafeLocale(props.lang)
    }));
    return {
      data: (_b = (_a = res.experienceCollection) == null ? void 0 : _a.items) == null ? void 0 : _b[0],
      rateLimited: (_c = res.rateLimited) != null ? _c : false
    };
  } catch (error) {
    throw new Exception({ error, name: "getExperienceDetailException" });
  }
});
var useGetExperienceDetail = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["getExperienceDetail", props],
    queryFn: () => getExperienceDetail(props)
  }, options));
};

export {
  getExperienceDetail,
  useGetExperienceDetail
};
//# sourceMappingURL=chunk-OSCTZDUD.mjs.map